<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">الإشعارات التسويقية</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">الإشعارات التسويقية</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="checkAccess('marketing_notifications_create')" class="row">
          <div class="col text-end">
            <router-link to="/mNotifications/create" class="btn btn-primary">
              <i class="bi bi-plus-circle me-1"></i> إضافة إشعار
            </router-link>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header"><div class="card-title">الإشعارات التسويقية</div></div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>مرسل إلى</th>
                            <th>العنوان</th>
                            <th>الإشعار</th>
                            <th>مجدول</th>
                            <th>تاريخ الجدولة</th>
                            <th>الحالة</th>
                            <th>وقت الإرسال</th>
                            <th>المُرسل</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, indx) in rows" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>{{ sendForObj[row.sendFor] }}</td>
                            <td>{{ row.title }}</td>
                            <td>{{ row.message }}</td>
                            <td>
                              <span v-if="row.isSchedule" class="badge bg-warning text-dark">مجدول</span>
                              <span v-else class="badge bg-success">فوري</span>
                            </td>
                            <td>{{ row.isSchedule ? formatDate(row.scheduleDate) : '-' }}</td>
                            <td>
                              <span v-if="!row.isSchedule" class="badge bg-success">تم الإرسال</span>
                              <span v-else-if="row.isSent" class="badge bg-success">تم الإرسال</span>
                              <span v-else class="badge bg-secondary">في الانتظار</span>
                            </td>
                            <td>{{ formatDate(row.createdAt) }}</td>
                            <td>{{ (row.Admin)? row.Admin.name : 'غير معروف' }}</td>
                            <td>
                              <router-link
                                v-if="isEditable(row) && checkAccess('marketing_notifications_update')"
                                :to="`/mNotifications/update/${row.id}`"
                                class="btn btn-sm"
                                title="تعديل الإشعار المجدول"
                              >
                                <i class="bi bi-pencil-square"></i>
                              </router-link>
                              <button
                                v-if="checkAccess('marketing_notifications_delete')"
                                class="btn btn-danger btn-sm"
                                @click="deleteRow(row.id, indx)"
                              >
                                <i class="bi bi-trash"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { toast, checkAccess, formatDate } from '@/helpers/tools';

export default {
  name: 'MNotificationsList',
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: 1,
      pages: [],
      sendForObj: {
        client: 'العميل',
        provider: 'المزود',
      },
    }
  },
  methods: {
    formatDate,
    checkAccess,
    isEditable(row) {
      return row.isSchedule && !row.isSent && new Date(row.scheduleDate) > new Date();
    },
    getList(){
      this.mainLoading = true;
      this.hasError = false;
      this.$http.get(`/api/admin/mNotifications/list?page=${this.currentPage}`).then(({data}) => {
        this.rows = data.rows;
        this.pages = data.pages ?? [this.currentPage];
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async deleteRow(id, index){
      const deletePrompt = await this.$swal.fire({
        title: "هل تريد تأكيد حذف السجل ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      });
      
      if (deletePrompt.isConfirmed) {
        this.$http.delete(`/api/admin/mNotifications/delete/${id}`).then(({data}) => {
          let buffer = this.rows;
          buffer.splice(index, 1);
          this.rows = buffer;
          // this.rows.splice(index, 1);
          toast('تم الحذف بنجاح', 'success');
        }).catch(err => {
          toast('غير قادر على الحذف');
        });
      }
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
  },
  created(){
    this.getList();
  }
}
</script>